// ================ Action types ================ //

// ================ Reducer ================ //

import { fetchCurrentUser } from '../../ducks/user.duck';

/** @type {import('../../../types/vansite').VanSite.State.SigninPage} */
const initialState = {};

const listingPageReducer = (state = initialState, action = {}) => {
  const { type } = action;
  switch (type) {
    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

// ================ Thunks ================ //

export const loadData = (params, search, match) => {
  return fetchCurrentUser(params);
};
